import {
  Zap,
  Flame,
  Droplets,
  Wifi,
  Smartphone,
  Home,
  Car,
  ShoppingCart,
  Utensils,
  Heart,
  Film,
  Plane,
  Gift,
  Book,
  Briefcase,
  CreditCard,
  DollarSign,
  Package,
  HelpCircle,
  type LucideIcon,
} from 'lucide-react'

const ICON_MAP: Record<string, LucideIcon> = {
  zap: Zap,
  flame: Flame,
  droplets: Droplets,
  wifi: Wifi,
  smartphone: Smartphone,
  home: Home,
  car: Car,
  'shopping-cart': ShoppingCart,
  shoppingcart: ShoppingCart,
  utensils: Utensils,
  heart: Heart,
  film: Film,
  plane: Plane,
  gift: Gift,
  book: Book,
  briefcase: Briefcase,
  creditcard: CreditCard,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  dollarsign: DollarSign,
  package: Package,
}

export function getCategoryIcon(name?: string | null): LucideIcon | null {
  if (!name) return null
  return ICON_MAP[name.toLowerCase()] || null
}

interface CategoryIconProps {
  name?: string | null
  className?: string
  fallback?: boolean
}

export function CategoryIcon({ name, className = 'h-3.5 w-3.5', fallback = false }: CategoryIconProps) {
  const Icon = getCategoryIcon(name)
  if (!Icon) return fallback ? <HelpCircle className={className} /> : null
  return <Icon className={className} />
}
